import type { IconData } from '@stacksjs/iconify-core'

export const laptop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M440 368a24.03 24.03 0 0 0 24-24V104a24.03 24.03 0 0 0-24-24H72a24.03 24.03 0 0 0-24 24v240a24.03 24.03 0 0 0 24 24ZM80 112h352v224H80ZM16 400h480v32H16z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default laptop
